import React from "react";
import "../styles/GlobalStyles.css";

const About = () => {
  return (
    <main className="page-wrap">
      <h2 style={{ marginBottom: "24px" }}>Gallery</h2>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
          gap: "16px"
        }}
      >
        {["/court1.jpeg", "/court2.jpeg", "/court3.jpeg"].map((src, i) => (
          <img
            key={i}
            src={src}
            alt={`Courtney ${i + 1}`}
            style={{
              width: "100%",
              aspectRatio: "4 / 5",
              objectFit: "cover",
              borderRadius: "var(--radius)",
              boxShadow: "var(--shadow)"
            }}
          />
        ))}
      </div>
    </main>
  );
};

export default About;
